import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translations from "./translations.json";

const defaultLanguage = "id";
const storedLanguage = localStorage.getItem("language") || defaultLanguage;

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: translations.en,
    },
    id: {
      translation: translations.id,
    },
  },
  lng: storedLanguage,
  fallbackLng: defaultLanguage,
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("language", lng);
});

export default i18n;
